import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@bcc/components/ui/dialog";
import { ProductSync, type ProductSyncProps } from "@bcc/components/products/product-sync";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { setProductSyncModalTestId } from "./product-sync-modal.utils";

export interface ProductSyncModalProps extends ProductSyncProps {
  expanded?: boolean;
  handleReload?: () => void;
  handleClose?: () => void | Promise<void>;
}

export function ProductSyncModal({
  expanded,
  handleClose = () => undefined,
  handleReload = () => undefined,
  ...props
}: ProductSyncModalProps) {
  const { t } = useTranslation();

  const handleSubmitSuccess = useCallback(async () => {
    handleReload();
    await handleClose();
  }, [handleClose, handleReload]);

  return (
    <Dialog
      open={Boolean(expanded)}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          void handleClose();
        }
      }}
    >
      <DialogContent className="sm:max-w-[1100px] max-h-[90vh] overflow-hidden" testId={setProductSyncModalTestId("content")}>
        <DialogHeader>
          <DialogTitle testId={setProductSyncModalTestId("title")}>
            {t("components.ProductSyncModal.title", {
              defaultValue: "Map products",
            })}
          </DialogTitle>
          <DialogDescription>
            {t("components.ProductSyncModal.description", {
              defaultValue: "Map your local products to remote variants and their grind options.",
            })}
          </DialogDescription>
        </DialogHeader>

        <ProductSync
          {...props}
          mode="modal"
          onCancel={() => {
            void handleClose();
          }}
          onSubmitSuccess={handleSubmitSuccess}
        />
      </DialogContent>
    </Dialog>
  );
}
